import _store from '@/store'
// import { getProjectByUrl } from '@/store/urls'

const setPrjCode = (path, store) => {
  if (!path || !store) return
  const project = store.state.project
  if (project && Object.keys(project).length) {
    store.commit('isDemo', path === project.demo)
    store.commit('isChangeLog', path === `/changelog/${project.key}`)
  }
}

export const config = router => {
  router.beforeEach(function (to, from, next) {
    window._hmt.push(['_trackPageview', window.location.pathname + '#' + to.fullPath])
    const storeObj = router.app.$store ? router.app.$store : _store
    setPrjCode(to.path, storeObj)
    next()
  })
}
